import React from 'react';
import { useSelector } from 'react-redux';
// dummyHierarchy.js
export const dummyHierarchyData = [
  {
    partnerId: 60,
    partnerName: 'Prakash Gaikwad',
    reportingManagerId: null,
    currentUser: true,
    level: 0,
    directCount: 6,
    totalCount: 45,
    children: [
      {
        partnerId: 70,
        partnerName: 'Vikas Bharadwaj',
        reportingManagerId: 60,
        currentUser: false,
        level: 1,
        directCount: 3,
        totalCount: 9,
        children: [
          {
            partnerId: 76,
            partnerName: 'Anagha Vaidya',
            reportingManagerId: 70,
            currentUser: false,
            level: 2,
            directCount: 2,
            totalCount: 2,
            children: [
              {
                partnerId: 201,
                partnerName: 'Rahul Deshmukh',
                reportingManagerId: 76,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              },
              {
                partnerId: 202,
                partnerName: 'Neha Patil',
                reportingManagerId: 76,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              }
            ]
          },
          {
            partnerId: 78,
            partnerName: 'Radheshyam Sharma',
            reportingManagerId: 70,
            currentUser: false,
            level: 2,
            directCount: 2,
            totalCount: 3,
            children: [
              {
                partnerId: 80,
                partnerName: 'Ganesh Panchal',
                reportingManagerId: 78,
                currentUser: false,
                level: 3,
                directCount: 1,
                totalCount: 1,
                children: [
                  {
                    partnerId: 301,
                    partnerName: 'Ritu Kulkarni',
                    reportingManagerId: 80,
                    currentUser: false,
                    level: 4,
                    directCount: 0,
                    totalCount: 0,
                    children: []
                  }
                ]
              },
              {
                partnerId: 203,
                partnerName: 'Suresh Yadav',
                reportingManagerId: 78,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              }
            ]
          },
          {
            partnerId: 84,
            partnerName: 'Anil Jaiswal',
            reportingManagerId: 70,
            currentUser: false,
            level: 2,
            directCount: 2,
            totalCount: 2,
            children: [
              {
                partnerId: 204,
                partnerName: 'Komal Singh',
                reportingManagerId: 84,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              },
              {
                partnerId: 205,
                partnerName: 'Amit Tiwari',
                reportingManagerId: 84,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              }
            ]
          }
        ]
      },

      {
        partnerId: 62,
        partnerName: 'Mukesh Pandey',
        reportingManagerId: 60,
        currentUser: false,
        level: 1,
        directCount: 3,
        totalCount: 6,
        children: [
          {
            partnerId: 210,
            partnerName: 'Pooja Kulkarni',
            reportingManagerId: 62,
            currentUser: false,
            level: 2,
            directCount: 2,
            totalCount: 2,
            children: [
              {
                partnerId: 310,
                partnerName: 'Rohan Mehta',
                reportingManagerId: 210,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              },
              {
                partnerId: 311,
                partnerName: 'Sneha Joshi',
                reportingManagerId: 210,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              }
            ]
          },
          {
            partnerId: 211,
            partnerName: 'Nikhil More',
            reportingManagerId: 62,
            currentUser: false,
            level: 2,
            directCount: 0,
            totalCount: 0,
            children: []
          },
          {
            partnerId: 212,
            partnerName: 'Farhan Khan',
            reportingManagerId: 62,
            currentUser: false,
            level: 2,
            directCount: 0,
            totalCount: 0,
            children: []
          }
        ]
      },

      {
        partnerId: 72,
        partnerName: 'Malav Shah',
        reportingManagerId: 60,
        currentUser: false,
        level: 1,
        directCount: 2,
        totalCount: 4,
        children: [
          {
            partnerId: 220,
            partnerName: 'Rakesh Solanki',
            reportingManagerId: 72,
            currentUser: false,
            level: 2,
            directCount: 2,
            totalCount: 2,
            children: [
              {
                partnerId: 320,
                partnerName: 'Nitin Rajput',
                reportingManagerId: 220,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              },
              {
                partnerId: 321,
                partnerName: 'Kavita Parmar',
                reportingManagerId: 220,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              }
            ]
          },
          {
            partnerId: 221,
            partnerName: 'Mehul Jain',
            reportingManagerId: 72,
            currentUser: false,
            level: 2,
            directCount: 0,
            totalCount: 0,
            children: []
          }
        ]
      },

      {
        partnerId: 74,
        partnerName: 'Moin',
        reportingManagerId: 60,
        currentUser: false,
        level: 1,
        directCount: 1,
        totalCount: 6,
        children: [
          {
            partnerId: 86,
            partnerName: 'Tukaram Holkarshinde',
            reportingManagerId: 74,
            currentUser: false,
            level: 2,
            directCount: 3,
            totalCount: 3,
            children: [
              {
                partnerId: 92,
                partnerName: 'Hemal Thakkar',
                reportingManagerId: 86,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              },
              {
                partnerId: 136,
                partnerName: 'Sweety Rahul Jain',
                reportingManagerId: 86,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              },
              {
                partnerId: 94,
                partnerName: 'Vishaka Pawar',
                reportingManagerId: 86,
                currentUser: false,
                level: 3,
                directCount: 0,
                totalCount: 0,
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
];

export default function useOnboardingSelector() {
  const OnboardingListData = useSelector((state) => state.Onboarding.list_data?.partners) || []; // List data
  const OnboardingViewData = useSelector((state) => state.Onboarding.view_data) || {}; // View
  const OnboardingShowCommision =
    useSelector((state) => state.Onboarding.commission_data?.commissions) || []; // View
  const HierarchyUserLevelListData =
    useSelector((state) => state.Onboarding.hierarchy_user?.hierarchy) || []; // List data
  const ReportingManagerListData =
    useSelector((state) => state?.Onboarding?.reporting_manager_list) || []; // List data

  const ReportingManagerListData2 =
    useSelector((state) => state?.Onboarding?.reporting_manager_list2) || []; // List data

  // console.log('buildTree HierarchyUserLevelListData', HierarchyUserLevelListData);
  return {
    OnboardingListData,
    OnboardingViewData,
    OnboardingShowCommision,
    HierarchyUserLevelListData,
    ReportingManagerListData,
    ReportingManagerListData2
  };
}
